<template>
  <div>
    <option-immediately></option-immediately>
    <option-time></option-time>
    <option-scroll></option-scroll>
    <option-exit></option-exit>
  </div>
</template>

<script>
import OptionImmediately from './Immediately.vue';
import OptionTime from './Time.vue';
import OptionExit from './Exit.vue';
import OptionScroll from './Scroll.vue';

export default {
  components: {
    OptionImmediately,
    OptionTime,
    OptionExit,
    OptionScroll,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?d946b764
 **/